import * as React from 'react';

import {SymbolBindingDot} from '../SymbolBindingDot';
import TooltipTrigger from '@packages/systems/design-system/TooltipTrigger';
import Hitarea from '@packages/systems/design-system/Hitarea';
import {ExpressionBinding} from '@packages/systems/ExpressionEditor-utils';
import {type Expression} from '@packages/systems/wfdl-ast';
import {styledDiv, type Theme} from '@packages/utilities/styled';
import {ContextualExpression} from '@packages/utilities/contextual-expression';

export const menuButtonSize = ({control}: {control: Theme['control']}) =>
  control.height - control.borderWidth * 2;
const MenuButtonWrapper = styledDiv(({theme}) => ({
  position: 'absolute',
  width: menuButtonSize(theme),
  height: menuButtonSize(theme),
  top: -theme.gutters.x8,
  left: -theme.gutters.x8,
}));

const InterpolatedTextDot = (props: {label: string; onClick: () => void}) => {
  const onMouseDown = (e: any) => {
    // Prevent binding dot from taking editor focus
    e.preventDefault();
  };

  return (
    <div data-automation-id={`binding-button_${props.label}`}>
      <TooltipTrigger alternate content="Insert variable">
        <Hitarea {...props}>
          <SymbolBindingDot
            clickable
            // @ts-expect-error - TS2322 - Type '{ clickable: true; onMouseDown: (e: any) => void; onClick: () => void; }' is not assignable to type 'IntrinsicAttributes & { keyboardFocus?: boolean | undefined; children?: undefined; active?: boolean | undefined; inline?: boolean | undefined; hover?: boolean | undefined; disabled?: boolean | undefined; onClick?: ((event: MouseEvent<...>) => void) | undefined; clickable?: boolean | undefined; style?: { ...; } | und...'.
            onMouseDown={onMouseDown}
            onClick={props.onClick}
          />
        </Hitarea>
      </TooltipTrigger>
    </div>
  );
};

export const MenuWithDot = React.memo<{
  expr: ContextualExpression;
  onChange: (arg1: null | Expression) => void;
  label: string;
}>(function MenuWithDot({expr, onChange, label}) {
  return (
    <MenuButtonWrapper>
      <ExpressionBinding
        automationLabel={label}
        expression={expr}
        onChange={onChange}
        button={(openPopover, targetRef) => (
          <span ref={targetRef}>
            <InterpolatedTextDot
              label={label}
              onClick={openPopover as () => void}
            />
          </span>
        )}
        bindUIVariant="custom"
      />
    </MenuButtonWrapper>
  );
});
